import { addressToBytes32, Options } from "@layerzerolabs/lz-v2-utilities";
import type { Address } from "abitype";
import { SendParam } from "logic/utils";
import { useMemo } from "react";
import { toHex } from "viem";

interface useDstChainSPParams {
  recipient: Address;
}

export function useDstChainSP(params: useDstChainSPParams) {
  const { recipient } = params;
  const lzReceiveGasLimit = 500_000n;

  const dstChainSP: SendParam = useMemo(() => {
    return {
      dstEid: 0,
      to: toHex(addressToBytes32(recipient)),
      amountLD: 0n,
      minAmountLD: 0n,
      extraOptions: Options.newOptions().addExecutorLzReceiveOption(lzReceiveGasLimit).toHex() as Address,
      composeMsg: "0x",
      oftCmd: "0x",
    };
  }, [lzReceiveGasLimit, recipient]);

  return { dstChainSP, lzReceiveGasLimit };
}
